import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CodeAndName } from '@lx/shared/types';

@Component({
  selector: 'lx-header-flag',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './header-flag.component.html',
  styleUrls: ['./header-flag.component.scss'],
})
export class HeaderFlagComponent {
  @Input() country!: CodeAndName;
}
